import { FC } from "react";
import ActionPageProps from "./ActionPage.types";
import ActionManager from "../../components/ActionManager";

const ActionPage: FC<ActionPageProps> = () => {
  return <ActionManager />;
};

export default ActionPage;
